import type { Toast } from "../../hooks/useToast";

const TYPE_STYLES: Record<string, { bg: string; border: string; icon: string }> = {
  success: { bg: "rgba(33,193,121,0.12)", border: "rgba(33,193,121,0.4)", icon: "✅" },
  error:   { bg: "rgba(255,77,109,0.12)", border: "rgba(255,77,109,0.4)", icon: "❌" },
  info:    { bg: "var(--bg-surface-2)",   border: "var(--border-accent)",  icon: "ℹ️" },
};

interface ToastStackProps {
  toasts: Toast[];
  dismiss: (id: number) => void;
}

export function ToastStack({ toasts, dismiss }: ToastStackProps) {
  if (!toasts.length) return null;
  return (
    <div
      style={{
        position: "fixed", bottom: 28, left: "50%", transform: "translateX(-50%)",
        display: "flex", flexDirection: "column", gap: 10, zIndex: 300, alignItems: "center",
        pointerEvents: "none",
      }}
    >
      {toasts.map((t) => {
        const s = TYPE_STYLES[t.type ?? "info"];
        return (
          <div
            key={t.id}
            className="toast"
            style={{
              background: s.bg, border: `1px solid ${s.border}`,
              display: "flex", alignItems: "center", gap: 10, pointerEvents: "all",
              cursor: "pointer", minWidth: 260, maxWidth: 400,
            }}
            onClick={() => dismiss(t.id)}
          >
            <span>{t.icon ?? s.icon}</span>
            <span style={{ flex: 1 }}>{t.message}</span>
            <span style={{ color: "var(--text-muted)", fontSize: 16, lineHeight: 1 }}>×</span>
          </div>
        );
      })}
    </div>
  );
}
